
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';

import { differenceInSeconds, addSeconds, isAfter, parse } from 'date-fns';
import min from 'date-fns/min/index.js';
// import { executeAtTime } from '@/utils/execute-at-time';

export default Vue.extend({
  name: 'AlertePanier',
  data () {
    return {
      loading: true,
      heureCloture: null as Date,
      dureeViePanier: null as number, // temps de vie du panier (secondes)
      delaiAlerteCloture: null as number, // delai avant alerte de cloture (secondes)
      timer: null,
      secondsLeft: null as number,
      clearClotureTimeout: () => { }
    };
  },
  computed: {
    ...mapGetters({ itemsOfPanier: 'panier/items', dateModificationPanier: 'panier/dateModification' }),
    isClosed (): boolean {
      // todo:store
      return isAfter(new Date(), this.heureCloture);
    },
    clotureImminente (): boolean {
      return isAfter(Date.now(), addSeconds(this.heureCloture, -this.dureeViePanier));
    },
    expirationDate (): Date {
      if (this.dateModificationPanier) {
        return min([this.heureCloture, addSeconds(this.dateModificationPanier, this.dureeViePanier)]);
      } else {
        return this.heureCloture;
      }
    },
    display (): boolean {
      return !!this.secondsLeft;
    }
  },
  watch: {
    expirationDate () {
      this.onChange();
    },
    itemsOfPanier () {
      this.onChange();
    }
  },
  mounted () {
    // Popup par défaut du navigateur pour confirmer le fait qu'on quitte la page si le panier est rempli
    // ==> Si on quitte, SESSION est clear, du coup le panier devient vide.
    window.addEventListener('beforeunload', (event) => {
      if (this.itemsOfPanier.length > 0 && process.env.NODE_ENV === 'production') {
        var message = 'Voulez vous sortir ?';
        /* InternetExplorer/Firefox */
        var e = event || window.event;
        e.returnValue = message;
        /* WebKit browser */
        return message;
      }
    });
  },
  created () {
    Promise.all([
      new Promise<{ value: string }>(resolve => { resolve({ value: '17:00:00' }); }), // todo get from backend
      new Promise<{ value: string }>(resolve => { resolve({ value: '15' }); }), // todo get from backend
      new Promise<{ value: string }>(resolve => { resolve({ value: '15' }); }) // todo get from backend
    ]).then(([paramHeureCloture, paramDureeViePanier, paramDelaiAlerteCloture]) => {
      this.heureCloture = parse(paramHeureCloture.value, 'HH:mm:ss', new Date());
      this.dureeViePanier = parseInt(paramDureeViePanier.value) * 60;
      this.delaiAlerteCloture = parseInt(paramDelaiAlerteCloture.value) * 60;

      // const dateAlerteCloture = addSeconds(this.heureCloture, -this.delaiAlerteCloture);
      // this.clearClotureTimeout = executeAtTime(() => this.alerteClotureImminente(), dateAlerteCloture);

      this.onChange();

      this.loading = false;
    });
  },
  beforeDestroy () {
    this.clearClotureTimeout();
    this.clearTimer();
  },
  methods: {
    ...mapActions({ viderPanier: 'panier/viderPanier', ajoutPanier: 'panier/ajouterItemPanier' }),

    defaultBrowserConfirmation (ev: any) {
      ev.returnValue = 'Panier remplie';
    },
    onChange () {
      this.clearTimer();
      if (this.itemsOfPanier.length === 0 || this.isClosed) {
        return;
      }

      const secondsLeft = differenceInSeconds(this.expirationDate, Date.now());
      if (secondsLeft <= this.dureeViePanier) {
        this.startTimer(secondsLeft);
      }
    },
    startTimer (seconds: number) {
      this.secondsLeft = seconds;
      this.timer = setInterval(() => {
        if (--this.secondsLeft < 0) {
          this.clearTimer();
          this.clearPanier();
        }
      }, 1000);
    },
    clearTimer () {
      clearInterval(this.timer);
      this.secondsLeft = null;
    },
    clearPanier () {
      // console.log((new Date()).toISOString(), this.heureCloture.toISOString());
      this.viderPanier();
      this.$dialog.warning({
        title: (this.isClosed ? 'Marché fermé' : 'Temps écoulé'),
        text: 'Votre panier a été vidé.'
      });
    },
    timeLeft (): string {
      if (this.secondsLeft <= 60) return `${this.secondsLeft} sec`;
      const result = Math.round(this.secondsLeft / 60);
      return `${result} min`;
    }
    // alerteClotureImminente () {
    //   this.$dialog.warning({
    //     title: 'Cloture imminente',
    //     text: 'Attention, la cloture du marché est imminente. Dépéchez vous de passer votre commande.'
    //   });
    // }
  }
});
